export const shouldDisplayVisuallySimilar = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.visualNavigation;
};

export const shouldDisplayIrgaccessories = (hideYMAN, data = {}) => {
  return (!hideYMAN && data?.product?.info?.recommendationFlags?.ACC);
};

export const shouldDisplayIrgcollections = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.collections;
};

const removeTypenameDeep = (input) => {
  if (Array.isArray(input)) {
    return input.map(removeTypenameDeep);
  }
  if (input && typeof input === 'object') {
    const { __typename, ...rest } = input;
    return Object.fromEntries(
      Object.keys(rest).map((key) => [key, removeTypenameDeep(rest[key])])
    );
  }
  return input;
};

export const getProductTaxonomy = (data = {}) => {
  return { taxonomy: removeTypenameDeep(data?.product?.taxonomy) };
};

export const shouldDisplayBBTAbove = (hideFBT, hideBBT, productData = {}) => {
  if (!hideFBT || hideBBT) return false;
  const recommendationFlags = productData?.product?.info?.recommendationFlags || {};
  const hasBundleOrPackages = Boolean(recommendationFlags.bundles || recommendationFlags.packages);

  return hideFBT && !hasBundleOrPackages;
};

export const shouldDisplayBBTBelow = (hideFBT, hideYMAN, hideBBT, productData = {}) => {
  if (!hideYMAN || hideBBT) return false;
  const recommendationFlags = productData?.product?.info?.recommendationFlags || {};
  const hasBundleOrPackages = Boolean(recommendationFlags.bundles || recommendationFlags.packages);

  return hideYMAN && (hasBundleOrPackages || !hideFBT);
};
